import React from 'react';
import Loader from '../../../components/Loader';
import { runFinicity } from '../../../services/integrationsService';
import FinicityConnectView from './FinicityConnect.view';
import FinicityWaitForAggregationView from './FinicityWaitForAggregation.view';
import { SkipBankingButtonWithoutState as SkipBankingButton } from '../SkipBankingButton';
import FinicityConnectError from './FinicityConnect.error';

export default class FinicityConnect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      connectUrl: null,
      hasError: false,
      showSkipBankingSurvey: false,
      waitToVerifyAggregationStatus: false,
      lastTimestamp: Date.now(),
      showSkipButton: false,
    };
  }

  async componentDidMount() {
    const { createScoringRequest } = this.props;
    let scoringRequest = {
      requestId: this.props.requestId,
      clientId: this.props.clientId,
    };
    if (createScoringRequest) {
      scoringRequest = await createScoringRequest();
      if (!scoringRequest || !scoringRequest.requestId || scoringRequest.error) {
        const message = 'Unable to create scoring request';
        // eslint-disable-next-line no-console
        console.error(message, scoringRequest);
        this.handleError(message);
        return;
      }
    }
    try {
      const result = await runFinicity(
        scoringRequest.requestId,
        scoringRequest.clientId,
        this.props.data,
      );
      if (result && result.length && !result[0].error) {
        this.setState({ connectUrl: result[0].link });
      }
    } finally {
      this.setState({ loading: false });
    }
  }

  handleCancel = async () => {
    if (this.props.skipBankingSurvey?.enabled
      && this.props.skipBankingSurvey.answers) {
      this.setState({ showSkipBankingSurvey: true });
    } else {
      this.props.nextStep(true);
    }
  };

  handleLoginComplete = async () => {
    this.setState({ waitToVerifyAggregationStatus: true });
  };

  handleAggregationComplete = async (success, fixLink, timestamp) => {
    if (!success && fixLink) {
      this.setState({
        connectUrl: fixLink,
        waitToVerifyAggregationStatus: false,
        lastTimestamp: timestamp,
      });
    } else {
      this.props.nextStep(false);
    }
  };

  handleError = async (error) => {
    // eslint-disable-next-line no-console
    console.error('Finicity Error:', error);
    this.setState({ hasError: true });
  };

  handleSkipBankingSurveyClose = async () => {
    this.setState({ showSkipBankingSurvey: false });
  };

  handleSkipBankingSurveyClosed = (didSkip) => {
    if (didSkip) {
      this.props.nextStep(true);
      return;
    }
    this.handleSkipBankingSurveyClose();
  };

  setShowSkipButton = (value) => {
    if (this.state.showSkipButton !== value) this.setState({ showSkipButton: value });
  };

  render() {
    if (this.state.hasError) return (<FinicityConnectError />);
    if (this.state.waitToVerifyAggregationStatus) {
      return (
        <FinicityWaitForAggregationView
          requestId={this.props.requestId}
          onComplete={this.handleAggregationComplete}
          lastTimestamp={this.state.lastTimestamp}
        />
      );
    }
    return (this.state.connectUrl
      && (
        <>
          { this.state.loading && (<Loader />) }
          {!this.state.showSkipBankingSurvey && (
            <FinicityConnectView
              clientId={this.props.clientId}
              requestId={this.props.requestId}
              url={this.state.connectUrl}
              onComplete={this.handleLoginComplete}
              onCancel={this.handleCancel}
              onError={this.handleError}
              showSkipButton={this.state.showSkipButton}
              setShowSkipButton={this.setShowSkipButton}
            />
          )}
          { !this.state.loading && (
            <SkipBankingButton
              clientId={this.props.clientId}
              requestId={this.props.requestId}
              showButton={this.state.showSkipButton}
              skipBankingSurvey={this.props.skipBankingSurvey}
              onSkipBanking={this.handleSkipBankingSurveyClosed}
              isOpen={this.state.showSkipBankingSurvey}
              onSkipButtonClick={() => this.setState({ showSkipBankingSurvey: true })}
            />
          )}
        </>
      )
    );
  }
}
